import { ActionTree }   from 'vuex';
import { RootState }    from '@/store/store.types';
import { State }        from '@/views/group-quotation-list/store/state.store';
import { getAllQuotes } from '@/views/group-quotation-list/service/group-quotation-list.service';
import { GroupQuote }   from '@/views/group-quotation-list/group-quotation-list.types';

const actions: ActionTree<State, RootState> = {
  async getAllQuotes({ commit }): Promise<void> {
    try {
      commit('setLoading', true);
      const { data }: { data: { quotes: GroupQuote[] } } = await getAllQuotes();
      commit('setAllQuotes', data.quotes);
    } catch (e) {
      throw Error(e);
    } finally {
      commit('setLoading', false);
    }
  },
};

export default actions;
